export default "__VITE_ASSET__bv5eLIKB__"